import { render, staticRenderFns } from "./UiCalendarWeek.vue?vue&type=template&id=dfaef9e4"
import script from "./UiCalendarWeek.vue?vue&type=script&lang=js"
export * from "./UiCalendarWeek.vue?vue&type=script&lang=js"
import style0 from "./UiCalendarWeek.vue?vue&type=style&index=0&id=dfaef9e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports